export default "__VITE_ASSET__q72vRJeJ__"